<!-- 首页导航栏菜单 -->
<template>
    <div class="nav">
        <!-- <div class="w"> -->
            <ul class="menu">
                <li v-for="item in menuList">
                    {{ item.menuName }}
                    <ul v-if="item.child != null && item.child.length > 0" class="child_menu"
                        :class="{ 'tow': item.child.length >= 8 && item.child.length <= 16, 'three': item.child.length >= 16 }">
                        <li v-for="childItem in item.child" @click="jumpMenu(childItem)">{{ childItem.menuName }}
                        </li>
                    </ul>
                </li>
            </ul>
        <div class="zhedie">
            <i class="el-icon-s-unfold menuicon" style="font-size: 18px;" @click="toshow" />
            <ul class="zmenu" v-if="show">
                <li v-for="item in menuList">
                    {{ item.menuName }}
                    <ul v-if="item.child != null && item.child.length > 0" class="child_menu1"
                        :class="{ 'tow': item.child.length >= 8 && item.child.length <= 16, 'three': item.child.length >= 16 }">
                        <li v-for="childItem in item.child" @click="jumpMenu(childItem)">{{ childItem.menuName }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <!-- </div> -->
    </div>
</template>
<script>

import { apiService } from "@/api/ApiService.js"
export default {
    name: 'Nav',
    data() {
        return {
            menuList: [],
            show: false
        }
    },
    mounted() {
        // 查询菜单
        apiService.findHomeMenu().then(res => {
            this.menuList = res.data
        })
    },
    methods: {
        toshow(){
          this.show = !this.show
        },
        // 处理菜单跳转功能
        jumpMenu(menuItem) {
            console.log('menuItem:', menuItem)
            // 招生就业功能使用新窗口打开页面
            if (menuItem.menuName == '就业指导') {
                window.open(menuItem.menuUrl, '_blank')
            } else {
                this.$router.push(menuItem.menuUrl)
            }
        }
    }
}
</script>
<style scoped>
    
.nav {
    position: fixed;
    width: 100%;
    z-index: 9999;
    top: 140px;
    color: rgb(5, 115, 184);
}

.menu {
    display: flex;
    width: 100%;
}

.menu>li {
    flex: 1;
    text-align: center;
    line-height: 60px;

    user-select: none;
    cursor: pointer;
    position: relative;
    font-size: 16px;
}

.menu>li:hover {
    background: rgb(24 110 165);
    color: white;
}

.menu>li:hover>.child_menu {
    display: flex;
}

.child_menu {
    position: absolute;
    z-index: 999;
    top: 60px;
    background: rgb(24 110 165);
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    display: none;
}

.child_menu>li {
    width: 100%;
    border-bottom: 1px solid rgb(5, 115, 184);
}

.child_menu>li:hover {
    background: rgb(5, 115, 184);
}

.child_menu.two {
    width: 200%;
}

.child_menu.two>li {
    width: 50%;
}

.child_menu.three {
    width: 300%;
}

.child_menu.three>li {
    width: 33.3333333333%;
}

.mobile {
        top: 0px;
        width: 100%;
        height: 40px;
        right: 0px;
        display: none;
        position: relative;
        z-index: 99;
    }

    .zhedie {
        display: none;
        height: 20px;
        line-height: 20px;
        /* background-color: #9BBAE8; */
        padding-left: 20px;
        position: relative;
    }
   
    .zmenu {
        position: absolute;
        top: 18px;
        left: 10px;
        height: auto;
        background: #11679D;
        width: 80px;
        color: white;
        padding: 10px;
    }

    .zmenu>li {
       height: 35px;
       line-height: 35px;
       border-bottom: 1px solid #ccc;
       text-align: center;
       position: relative;
    }

    
    .zmenu>li:hover {
        background: white;
        color: #11679D;
        text-align: center;
        
    }

    .zmenu>li:hover>.child_menu1 {
        display: flex;
        /* height: 100px;
        width: 306px; */
        flex-wrap: wrap;
        min-height: 46px;
        width: 359px;
    }


    .zmenu>li:hover>.child_menu1>li {
        width: 110px;
        height: 35px;
        color: white;
        display: inline-block;
        padding: 3px;
        font-size: 12px;
    }
@media screen and (max-width: 768PX)  {
      
        .zhedie {
            display: block;
            position: absolute;
            top: -126px;
            color: white;
            left: -9px;
        }
        .nav {
            width: 100%;
            height: 20px;
            line-height: 20px;
        }

        .w {
            overflow: auto;
            width: 100%;
            white-space: nowrap;
        }
        .menu {
            display: none;
            /* width: auto; */
        }

        .menu>li {
            height: 60px;
            width: 110px;
            text-align: center;
            line-height: 60px;
            user-select: none;
            cursor: pointer;
            position: relative;
            font-size: 12px;
            float: left;
            /* display: i?nline-block;            */
        }

        .child_menu1 {
            position: absolute;
            z-index: 999;
            left: 89px;
            top: -10px;
            background: rgb(24 110 165);
            display: none;
            /* width: auto; */
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/Nav.vue